export default class PatientDemographics {
  constructor({
    firstName,
    preferredName,
    lastName,
    dateOfBirth,
    sex,
    genderInformation,
    email,
    phone,
    address,
  }) {
    this.firstName = firstName;
    this.preferredName = preferredName;
    this.lastName = lastName;
    this.dateOfBirth = dateOfBirth;
    this.sex = sex;
    this.genderInformation = genderInformation;
    this.email = email;
    this.phone = phone;
    this.address = address;
  }

  toLuminisApiObject() {
    return {
      firstName: this.firstName,
      preferredName: this.preferredName,
      lastName: this.lastName,
      dateOfBirth: this.dateOfBirth,
      sex: this.sex,
      genderInformation: this.genderInformation,
      email: this.email,
      primaryPhone: this.phone.toLuminisApiObject(),
      primaryAddress: this.address.toLuminisApiObject(),
    };
  }
}
